import { render, staticRenderFns } from "./FoldersList.vue?vue&type=template&id=1fc56d8e&scoped=true&"
import script from "./FoldersList.vue?vue&type=script&setup=true&lang=js&"
export * from "./FoldersList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc56d8e",
  null
  
)

export default component.exports